function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 4c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4zm-4 2.5c0 .8-.7 1.5-1.5 1.5S11 7.3 11 6.5 11.7 5 12.5 5s1.5.7 1.5 1.5zm-5.6 2c-.4-.6-1.4-.6-1.8 0l-2.8 5c-.3.7.1 1.5.9 1.5h10.5c.8 0 1.3-.8.9-1.5l-1.8-3c-.4-.7-1.3-.7-1.7 0l-.7 1.3c-.4.7-1.4.7-1.7 0L8.4 8.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgGallery;